import Vue from 'vue';
import { getCoordinates, ICoordinates } from '../util/getCoordinates';
import { Glossary } from '../types/pageContract';

interface IGlossary {
  glossaryActive: boolean;
  glossaries: object;
  currentGlossary: Glossary | null;
  coordinates: ICoordinates | null;
}

const state: IGlossary = Vue.observable({
  glossaries: {},
  glossaryActive: false,
  currentGlossary: null,
  coordinates: null
});

class GlossaryStore {
  get glossaryActive(): boolean {
    return state.glossaryActive;
  }

  get currentGlossary(): Glossary | null {
    return state.currentGlossary;
  }

  get coordinates(): ICoordinates | null {
    return state.coordinates;
  }

  public showGlossary(elm: HTMLElement, event: any, uid: string): void {
    state.glossaryActive = false;

    GlossaryStore.setCurrentGlossary(uid);
    setTimeout(() => {
      const wrapper = document.querySelector('.v-main__wrap');
      state.glossaryActive = true;
      if (wrapper) {
        state.coordinates = getCoordinates(elm, event, wrapper);
      }
    });
  }

  private static setCurrentGlossary(uid: string): void {
    if (state.glossaries) {
      // @ts-ignore
      state.currentGlossary = state.glossaries[uid.toLowerCase()];
    }
  }

  public getGlossaries(glossaries: object): void {
    state.glossaries = glossaries;
  }

  public closeGlossary(): void {
    state.glossaryActive = false;
  }
}

export default new GlossaryStore();
